import React from "react";
import Colors from "../../constants/Colors";
import "../Link.css";

interface ImageSquareProps {
  src: string;
  alt: string;
  size: number;
  onClick: () => void;
}

const ImageSquare = (props: ImageSquareProps) => {
  const { src, alt, onClick, size } = props;
  const computedStyle = {
    width: size,
    height: size,
    ...styles.square,
  };
  return (
    <img
      className="link"
      onClick={onClick}
      src={src}
      alt={alt}
      style={computedStyle}
    />
  );
};

const styles = {
  square: {
    backgroundColor: Colors.grayLight,
    objectFit: "cover",
    marginBottom: "0px",
  } as React.CSSProperties,
};

export default ImageSquare;
